export {
  XpmContactSupportModal,
  type XpmContactSupportModalProps,
} from './XpmContactSupportModal';
